import { useReducer } from 'react';
import { ReportableDataReducer } from './ReportableDataReducer';
import {
  IAction,
  IState,
  ReportableDataDispatchContext,
  ReportableDataStateContext,
  setInititalContext,
} from './UseReportableDataContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface IReportableDataProviderProps {
  children: any;
  value?: IValue;
  timezone: string;
}

export function ReportableDataProvider({
  children,
  timezone,
  value = { initialState: setInititalContext(timezone), reducer: ReportableDataReducer },
}: IReportableDataProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <ReportableDataStateContext.Provider value={state}>
      <ReportableDataDispatchContext.Provider value={dispatch}>{children}</ReportableDataDispatchContext.Provider>
    </ReportableDataStateContext.Provider>
  );
}
